import { render, staticRenderFns } from "./Step14.vue?vue&type=template&id=87c53b86&scoped=true"
import script from "./Step14.vue?vue&type=script&lang=js"
export * from "./Step14.vue?vue&type=script&lang=js"
import style0 from "./Step14.vue?vue&type=style&index=0&id=87c53b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c53b86",
  null
  
)

export default component.exports